<template>
	<div>
		<e-header></e-header>
		<transition name="move" mode="out-in">
			<router-view :key="$route.fullPath"></router-view>
		</transition>
		<e-footer></e-footer>
	</div>
</template>
 
<script>
// @ is an alias to /src
import eHeader from '@/components/Header'
import eFooter from '@/components/Footer'

export default {
	name: 'main',
	components: {
		eHeader,
		eFooter
	}
}
</script>


<style>
.el-main{
	padding: 0;
	overflow: visible;
}
.header{
	background: #181413;
	z-index: 1;
	.content{
		background: #181413;
	}
}
</style>